<template>
  <el-date-picker
    v-model="value"
    type="date"
    value-format="x"
    :placeholder="`请选择${item?.fieldName}`"
    @change="mySubmit"
    v-if="isEditor"
  />
  <div v-else>{{ dateFormatEx(value) }}</div>
</template>
<script>
import { defineComponent } from 'vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 't-date',
  inheritAttrs: false,
  props: { ...baseProps, modelValue: { type: Number } },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    const dateFormatEx = (value) => {
      if (!value || value == '') {
        return ''
      }
      if (('' + value) / length <= 10) {
        value = value * 1000
      }
      let time = new Date(value)
      let y = time.getFullYear()
      let m = time.getMonth() + 1
      let d = time.getDate()
      m = m > 9 ? m : '0' + m
      d = d > 9 ? d : '0' + d
      return `${y}/${m}/${d}`
    }
    return {
      ...controlItemManage(props, context),
      dateFormatEx
    }
  }
})
</script>
